<template>
  <div>
    <v-btn
      @click="onClick"
      :class="{
        expandButtonContentStart: !justifyEnd,
        expandButtonContentEnd: justifyEnd,
      }"
      class="expandButton"
      flat
      large
    >
      <v-icon>{{ expandIconName }}</v-icon>
      {{ buttonText }}
    </v-btn>
    <v-slide-y-transition>
      <div v-if="showSlot" :class="space">
        <slot />
      </div>
    </v-slide-y-transition>
  </div>
</template>

<script>
export default {
  name: 'AdvancedSetting',
  props: {
    buttonText: {
      type: String,
      default: '高度な設定',
    },
    justifyEnd: {
      type: Boolean,
      default: false,
    },
    space: {
      type: String,
      default: 'mt-4',
    },
  },
  data() {
    return {
      showSlot: false,
    }
  },
  computed: {
    expandIconName() {
      return this.showSlot ? 'keyboard_arrow_up' : 'keyboard_arrow_down'
    },
  },
  methods: {
    onClick() {
      this.showSlot = !this.showSlot
      this.$emit('toggle', this.showSlot)
    },
  },
}
</script>

<style scoped lang="scss">
.expandButton {
  width: 100%;
  margin: 0;
  padding: 0;
}
.expandButtonContentStart {
  ::v-deep .v-btn__content {
    justify-content: flex-start;
  }
}
.expandButtonContentEnd {
  ::v-deep .v-btn__content {
    justify-content: flex-end;
  }
}
</style>
